import { render, staticRenderFns } from "./FundingModal.vue?vue&type=template&id=24946c68&scoped=true&"
import script from "./FundingModal.vue?vue&type=script&lang=js&"
export * from "./FundingModal.vue?vue&type=script&lang=js&"
import style0 from "./FundingModal.vue?vue&type=style&index=0&id=24946c68&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24946c68",
  null
  
)

export default component.exports